import moment from 'moment';

// Flags for enabling/disabling features
export const testConnectSidebarEnabled = true;
export const suggestedProductsEnabled = true;
export const integrationsTabEnabled = true;
export const newNotesEnabled = true;
export const outdateAlexProErrorOnNotificationBar = false;
export const shelfIntegrationEnabled = true;
export const trublueMemberIDEnabled = moment().isSameOrBefore(moment('2018 12 31', 'YYYY MM DD'));